var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRolesFullAccessDataSteward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52 39.657a31.68 31.68 0 1063.36 0 31.68 31.68 0 00-63.36 0z",
    fill: "#E1F1CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.913 61.91v1.188a1.01 1.01 0 01-1.01 1.01H10.348a1.009 1.009 0 01-1.009-1.005v-1.188a15.787 15.787 0 1131.575 0v-.005z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.913 61.91v1.188a1.01 1.01 0 01-1.01 1.01H10.348a1.009 1.009 0 01-1.009-1.005v-1.188a15.787 15.787 0 1131.575 0v-.005z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.769 48.76a4.339 4.339 0 01-7.287 0c0 1.392 1.882 6.515 2.941 9.287a.753.753 0 001.406 0c1.059-2.772 2.94-7.895 2.94-9.287z",
    fill: "#fff",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.769 48.76a4.338 4.338 0 01-7.287 0v-5.465h7.287v5.465z",
    fill: "#fff",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.769 48.76a4.338 4.338 0 01-7.287 0v-5.465h7.287v5.465z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.842 69.577V49.471a15.751 15.751 0 00-6.072-2.92v2.217c0 1.393-1.882 6.515-2.941 9.288a.753.753 0 01-1.406 0c-1.059-2.772-2.94-7.895-2.94-9.287v-2.218a15.753 15.753 0 00-6.073 2.924v20.102",
    fill: "#C4E299"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.842 69.577V49.471a15.751 15.751 0 00-6.072-2.92v2.217c0 1.393-1.882 6.515-2.941 9.288a.753.753 0 01-1.406 0c-1.059-2.772-2.94-7.895-2.94-9.287v-2.218a15.753 15.753 0 00-6.073 2.924v20.102",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.842 69.577V49.471a15.751 15.751 0 00-6.072-2.92v2.217c0 1.393-1.882 6.515-2.941 9.288a.753.753 0 01-1.406 0c-1.059-2.772-2.94-7.895-2.94-9.287v-2.218a15.753 15.753 0 00-6.073 2.924v20.102",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.553 69.572v-5.465h4.857v5.465",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.553 69.572v-5.465h4.857v5.465",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.41 61.68h19.431v3.035h-19.43V61.68z",
    fill: "#fff",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.41 69.573v-2.428h19.432v2.428",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.41 69.573v-2.428h19.432v2.428",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.542 70.497h-.038a3.01 3.01 0 01-2.805-3.063v-3.327h-4.857v5.465c0 .628 1.072 4.837 6.383 5.896.31.062.622.103.936.122a2.678 2.678 0 002.852-2.086 2.555 2.555 0 00-2.471-3.007zM34.878 32.806v-2.438a9.751 9.751 0 00-19.502 0v2.438a1.95 1.95 0 000 3.9c.041 0 .08-.009.12-.012a9.742 9.742 0 0019.262 0c.041 0 .08.013.12.013a1.952 1.952 0 001.404-3.344 1.951 1.951 0 00-1.404-.557z",
    fill: "#fff",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.302 36.95a1.219 1.219 0 102.437 0 1.219 1.219 0 00-2.437 0zM29.515 36.95a1.219 1.219 0 102.437 0 1.219 1.219 0 00-2.437 0z",
    fill: "#C4E299"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.193 39.422a4.255 4.255 0 005.867 0M30.49 33.78a1.59 1.59 0 00-2.93 0M22.681 33.78a1.59 1.59 0 00-2.93 0",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.442 29.096c0 .1-.016.197-.016.297v9.444c0 2.78 1.014 5.463 2.851 7.549a.488.488 0 00.847-.4c-.675-4.18-2.204-11.15 1.866-14.347a11.125 11.125 0 002.388-2.543h-7.936zM30.58 29.096c2.208 1.99 3.617 4.197 5.76 4.197v-3.9c0-.1-.012-.198-.015-.297H30.58z",
    fill: "#fff",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.652 28.158a10.439 10.439 0 00-10.324-10.119h-2.302A10.439 10.439 0 0013.7 28.158h22.952z",
    fill: "#C4E299"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.652 28.158a10.439 10.439 0 00-10.324-10.119h-2.302A10.439 10.439 0 0013.7 28.158h22.952zM31.837 18.037l-.606 6.66M18.517 18.037l.605 6.66",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.814 28.334h4.725c.091-.148.148-.314.168-.486l1.013-9.575a.998.998 0 00-.72-1.079 11.075 11.075 0 00-5.647 0 1 1 0 00-.721 1.079l1.014 9.575c.02.172.076.338.168.486z",
    fill: "#C4E299"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.814 28.334h4.725c.091-.148.148-.314.168-.486l1.013-9.575a.998.998 0 00-.72-1.079 11.075 11.075 0 00-5.647 0 1 1 0 00-.721 1.079l1.014 9.575c.02.172.076.338.168.486z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 28.156h27.753v2.524H11.25v-2.524z",
    fill: "#C4E299",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42.542 70.497h-.038a3.01 3.01 0 01-2.805-3.063v-3.327h-4.857v5.465c0 .628 1.072 4.837 6.383 5.896.31.062.622.103.936.122a2.678 2.678 0 002.852-2.086 2.555 2.555 0 00-2.471-3.007z",
    fill: "#fff",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.383 74.626l4.694-11.097a4.09 4.09 0 012.493-2.292 4.514 4.514 0 003.13-4.973 4.407 4.407 0 00-1.232-2.376.124.124 0 00-.161-.013.125.125 0 00-.038.043l-1.188 2.353a.567.567 0 01-.328.281l-1.299.425a.57.57 0 01-.178.028l-5.302-.028a.452.452 0 00-.339.755 5.667 5.667 0 01.102 6.06l-5.049 8.455a2.632 2.632 0 104.695 2.376v.003zm-3.312-.87a1.015 1.015 0 11.194.342 1.013 1.013 0 01-.194-.346v.003z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.006 57.005l-.629-1.925a.564.564 0 01.033-.43l.976-1.922a.084.084 0 000-.079.08.08 0 00-.07-.04c-.449.006-.894.08-1.32.22a4.924 4.924 0 00-3.112 4.156l4.122.02z",
    fill: "#C4E299"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50.006 57.005l-.629-1.925a.564.564 0 01.033-.43l.976-1.922a.084.084 0 000-.079.08.08 0 00-.07-.04c-.449.006-.894.08-1.32.22a4.924 4.924 0 00-3.112 4.156l4.122.02zM47.551 62.553l-4.218 8.323M47.268 59.516l-1.855.044",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M47.142 59.128l1.929-.632.631 1.93-1.929.63-.631-1.928z",
    fill: "#C4E299",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.268 53.916l-1.188 2.353a.567.567 0 01-.328.28l-1.299.425a.565.565 0 01-.178.029l-5.302-.029a.452.452 0 00-.339.756 5.667 5.667 0 01.102 6.059l-5.048 8.458a2.632 2.632 0 004.694 2.38l4.695-11.098a4.088 4.088 0 012.492-2.292 4.514 4.514 0 003.13-4.973 4.406 4.406 0 00-1.232-2.376.124.124 0 00-.107-.035.125.125 0 00-.092.065v-.002z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M41.02 73.437a1.015 1.015 0 102.031 0 1.015 1.015 0 00-2.03 0z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M47.353 75.272a1.078 1.078 0 01-1.035.773h-2.494a2.589 2.589 0 01-2.59-2.589v-1.294a2.59 2.59 0 012.59-2.59h2.494a1.077 1.077 0 011.035.775 8.712 8.712 0 010 4.925z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M47.353 75.272a1.078 1.078 0 01-1.035.773h-2.494a2.589 2.589 0 01-2.59-2.589v-1.294a2.59 2.59 0 012.59-2.59h2.494a1.077 1.077 0 011.035.775 8.712 8.712 0 010 4.925z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M67.661 17.22h-2.396a11.293 11.293 0 00-1.721-4.152l1.693-1.694a.872.872 0 000-1.234l-1.85-1.854a.87.87 0 00-1.235 0L60.459 9.98a11.302 11.302 0 00-4.152-1.721V5.865a.871.871 0 00-.871-.87h-2.623a.871.871 0 00-.87.87V8.26a11.3 11.3 0 00-4.153 1.72l-1.692-1.693a.872.872 0 00-1.234 0L43.01 10.14a.872.872 0 000 1.234l1.694 1.694a11.291 11.291 0 00-1.721 4.152h-2.398a.871.871 0 00-.871.871v2.621a.872.872 0 00.871.871h2.393c.29 1.486.875 2.898 1.721 4.152l-1.69 1.697a.87.87 0 000 1.235l1.854 1.853a.87.87 0 001.234 0l1.694-1.693a11.288 11.288 0 004.149 1.724v2.394a.871.871 0 00.871.87h2.62a.87.87 0 00.871-.87V30.55a11.29 11.29 0 004.152-1.72l1.693 1.692a.871.871 0 001.236 0l1.852-1.853a.872.872 0 000-1.235l-1.693-1.693a11.289 11.289 0 001.723-4.155h2.393a.871.871 0 00.871-.87v-2.624a.87.87 0 00-.868-.873zm-13.538 8.738a6.551 6.551 0 11-.005-13.103 6.551 6.551 0 01.005 13.103z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M54.124 25.959a6.551 6.551 0 11-.006-13.103 6.551 6.551 0 01.006 13.103z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M67.661 17.22h-2.396a11.293 11.293 0 00-1.721-4.152l1.693-1.694a.872.872 0 000-1.234l-1.85-1.854a.87.87 0 00-1.235 0L60.459 9.98a11.302 11.302 0 00-4.152-1.721V5.865a.871.871 0 00-.871-.87h-2.623a.871.871 0 00-.87.87V8.26a11.3 11.3 0 00-4.153 1.72l-1.692-1.693a.872.872 0 00-1.234 0L43.01 10.14a.872.872 0 000 1.234l1.694 1.694a11.291 11.291 0 00-1.721 4.152h-2.398a.871.871 0 00-.871.871v2.621a.872.872 0 00.871.871h2.393c.29 1.486.875 2.898 1.721 4.152l-1.69 1.697a.87.87 0 000 1.235l1.854 1.853a.87.87 0 001.234 0l1.694-1.693a11.288 11.288 0 004.149 1.724v2.394a.871.871 0 00.871.87h2.62a.87.87 0 00.871-.87V30.55a11.29 11.29 0 004.152-1.72l1.693 1.692a.871.871 0 001.236 0l1.852-1.853a.872.872 0 000-1.235l-1.693-1.693a11.289 11.289 0 001.723-4.155h2.393a.871.871 0 00.871-.87v-2.624a.87.87 0 00-.868-.873zm-13.538 8.738a6.551 6.551 0 11-.005-13.103 6.551 6.551 0 01.005 13.103z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M73.016 44.795l-.613-.353a7.265 7.265 0 000-3.97l.613-.353a.929.929 0 00.34-1.267l-.93-1.609a.926.926 0 00-1.267-.34l-.609.352a7.419 7.419 0 00-3.44-1.98v-.707a.929.929 0 00-.93-.93h-1.857a.929.929 0 00-.928.93v.707a7.418 7.418 0 00-3.442 1.98l-.609-.352a.928.928 0 00-1.267.34l-.93 1.607a.929.929 0 00.34 1.267l.612.354a7.263 7.263 0 000 3.969l-.612.353a.929.929 0 00-.34 1.267l.93 1.608a.927.927 0 001.266.34l.61-.349a7.414 7.414 0 003.441 1.98v.713a.929.929 0 00.929.929h1.857a.929.929 0 00.929-.929v-.713a7.415 7.415 0 003.44-1.98l.61.351a.928.928 0 001.267-.34l.929-1.607a.929.929 0 00-.34-1.268zm-7.762 1.84a4.179 4.179 0 11.005-8.357 4.179 4.179 0 01-.007 8.357h.002z",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M73.016 44.795l-.613-.353a7.265 7.265 0 000-3.97l.613-.353a.929.929 0 00.34-1.267l-.93-1.609a.926.926 0 00-1.267-.34l-.609.352a7.419 7.419 0 00-3.44-1.98v-.707a.929.929 0 00-.93-.93h-1.857a.929.929 0 00-.928.93v.707a7.418 7.418 0 00-3.442 1.98l-.609-.352a.928.928 0 00-1.267.34l-.93 1.607a.929.929 0 00.34 1.267l.612.354a7.263 7.263 0 000 3.969l-.612.353a.929.929 0 00-.34 1.267l.93 1.608a.927.927 0 001.266.34l.61-.349a7.414 7.414 0 003.441 1.98v.713a.929.929 0 00.929.929h1.857a.929.929 0 00.929-.929v-.713a7.415 7.415 0 003.44-1.98l.61.351a.928.928 0 001.267-.34l.929-1.607a.929.929 0 00-.34-1.268zm-7.762 1.84a4.179 4.179 0 11.005-8.357 4.179 4.179 0 01-.007 8.357h.002z",
    stroke: "#406E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgRolesFullAccessDataSteward;